import React from "react";
import Head from "../../components/Head/Head";
import Hero from "../../components/Hero/Hero";
import About from "../../components/About/About";
import NavBar from "../../components/NavBar/NavBar";
import Footer from "../../components/Footer/Footer";

import "./Home.css";

const Home = () => {
  return (
    <div className="home">
      <Head
        title={"Certified Translation services-Interpretation | localization"}
        description={
          "Oneconverse is a trusted translation & interpretation agency. Go global with our certified translation, interpretation services, and translators near you."
        }
        keywords={
          "translation, interpretation, certified, services, language, conference interpreter, document, localization, translators, interpreter, translator, translation company, translation services, translation companies, translation agencies, document translation, translation services near me, translate document, document translation service, document translation services online, simultaneous interpretation services, multilingual services, sworn translators, certified translations"
        }
      />
      <NavBar white home />
      <Hero />
      <About />
      <Footer />
    </div>
  );
};

export default Home;
